module.exports = __webpack_public_path__ + "img/upload-vehicle_front.9f1daeee.png";